import LoginFLowRepository from "@adapters/features/LoginFlow/Repository/LoginFlow";
export default (http) => {
    return {
        login: new LoginFLowRepository(http),
    };
};
